export async function validarValorTomaUsado(valorDeToma, appraisal, rule) {
  await new Promise((resolve) => setTimeout(resolve, 2000))
  return (
    Number(valorDeToma) <= Math.abs(Number(appraisal * (1 + rule.tomausado / 100))) || Number(valorDeToma) < appraisal
  )
}
